import './index.css';
import App from './App';
import ReactDOM from 'react-dom';
import { integrations } from 'config';
import { getEnvironment } from 'utils';
import * as Sentry from '@sentry/browser';
import packageInfo from '../package.json';

const ignoreErrors = [
  "Cannot read property 'getBoundingClientRect' of null",
  "Cannot read properties of null (reading 'getBoundingClientRect')",
  "null is not an object (evaluating 'n.container.getBoundingClientRect')",
  "TypeError: null is not an object (evaluating 'n.container.getBoundingClientRect')",
  'EvalError',
  'ResizeObserver loop limit exceeded',
  // AGI-59949 (MC3-XV / MC3-XT). Thrown by the Google Maps marker drag helper from its
  // document-level pointermove/pointerup listeners when the drag origin is null. No
  // first-party frame is involved and the app keeps working; the only user-visible effect
  // was the crash-report dialog. ignoreErrors runs as an InboundFilters event processor,
  // i.e. before beforeSend, so filtering here also stops showReportDialog() from firing
  // for this signature without changing dialog behaviour anywhere else.
  "Cannot read properties of null (reading 'clientX')",
];

const environment = getEnvironment();

const enableSentryPlugins = integrations?.deployment === 'development';

if (integrations?.logging) {
  Sentry.init({
    release: `${packageInfo.name}@${packageInfo.version}`,
    environment,
    dsn: integrations.sentry,
    ignoreErrors,
    beforeSend(event) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        Sentry.showReportDialog();
      }
      return event;
    },
    replaysOnErrorSampleRate: 1.0,
    integrations: enableSentryPlugins
      ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
      : [],
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
